import { render, staticRenderFns } from "./IncomeInformation.vue?vue&type=template&id=2068f417&"
import script from "./IncomeInformation.vue?vue&type=script&lang=js&"
export * from "./IncomeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports